import $paths from "@/constants/route-paths";
import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

// Auth routes meta
const meta = { layout: layouts.auth, requiresAuth: false };

/**
 * Authentication routes
 */
const authRoutes = [
  {
    path: $paths.login,
    name: "login",
    meta,
    component: () => import("@/views/Auth/Login.vue"),
  },
  {
    path: $paths.loggedOut,
    name: "logged-out",
    meta,
    component: () => import("@/views/Auth/LoggedOut.vue"),
  },
];

export default authRoutes;
